import ReactDOMServer from 'react-dom/server';
import moment from 'moment-timezone';
import React from 'react';
import { round } from 'lodash';
import styled from 'styled-components';

import { dateColumns } from '../../constants/event';

const TooltipHeader = styled.div`
  font-size: 10px;
`;

const TooltipContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const hourGroupHeaderTooltip = (hoverPoint, timezone) => {
  const date = moment.tz(hoverPoint.x, timezone);
  const formatDate = date.format('dddd, MMM D, HH:mm', timezone);

  return <TooltipHeader>{formatDate}</TooltipHeader>;
};

const dayGroupHeaderTooltip = (hoverPoint, timezone) => {
  const date = moment.tz(hoverPoint.x, timezone);
  const formatDate = date.format('dddd, MMM D, YYYY', timezone);

  return <TooltipHeader>{formatDate}</TooltipHeader>;
};

const weekGroupHeaderTooltip = (hoverPoint, timezone, amountOfPoints) => {
  const date = moment.tz(hoverPoint.x, timezone);
  const formatDate = date.format('dddd, MMM D, YYYY', timezone);

  const onePointDate = moment.tz(hoverPoint.x, timezone);
  const formatOnePointDate = onePointDate.format('dddd, MMM D, YYYY', timezone);

  return amountOfPoints > 1 ? (
    <TooltipHeader>Week from {formatDate}</TooltipHeader>
  ) : (
    <TooltipHeader>{formatOnePointDate}</TooltipHeader>
  );
};

const monthGroupHeaderTooltip = (hoverPoint, timezone, amountOfPoints) => {
  const date = moment.tz(hoverPoint.x, timezone);
  const formatDate = date.format('MMMM YYYY', timezone);

  const formatOnePointDate = date.format('dddd, MMM D, YYYY', timezone);

  return amountOfPoints > 1 ? (
    <TooltipHeader>{formatDate}</TooltipHeader>
  ) : (
    <TooltipHeader>{formatOnePointDate}</TooltipHeader>
  );
};

const quarterGroupHeaderTooltip = (hoverPoint, timezone) => {
  const date = moment.tz(hoverPoint.x, timezone);
  const quarter = date.quarter();
  const formatDate = date.format(`[Q${quarter},] YYYY`, timezone);

  return <TooltipHeader>{formatDate}</TooltipHeader>;
};

const LineChartTooltip = (hoverPoint, { timezone, groupBy }, isPaying, amountOfPoints) => {
  let tooltipHeader;

  switch (groupBy) {
    case dateColumns.HOUR:
      tooltipHeader = hourGroupHeaderTooltip(hoverPoint, timezone);
      break;
    case dateColumns.DAY:
      tooltipHeader = dayGroupHeaderTooltip(hoverPoint, timezone);
      break;
    case dateColumns.WEEK:
      tooltipHeader = weekGroupHeaderTooltip(hoverPoint, timezone, amountOfPoints);
      break;
    case dateColumns.MONTH:
      tooltipHeader = monthGroupHeaderTooltip(hoverPoint, timezone, amountOfPoints);
      break;
    case dateColumns.QUARTER:
      tooltipHeader = quarterGroupHeaderTooltip(hoverPoint, timezone);
      break;

    default:
      break;
  }

  const value = round(hoverPoint.y, 2);
  const valueSymbol = isPaying ? '%' : '';
  const { name } = hoverPoint.series;

  return ReactDOMServer.renderToStaticMarkup(
    <TooltipContainer>
      {tooltipHeader}
      <div>
        <span style={{ color: hoverPoint.color }}>●</span> {name}: <b>{`${value}${valueSymbol}`}</b>
        <br />
      </div>
    </TooltipContainer>
  );
};

export default LineChartTooltip;
